import React from "react";
import * as c from "./lpCompetitorTable.module.scss";
import classNames from "classnames";
import competitorData from "./competitorData";
import IconCheckmark from "@components/icons/iconCheckmark";

const StarRating = ({ rating }) => (
  <span className={c.starRating}>
    {rating}{" "}
    <span className={c.star}>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M6.53601 1.15543C6.70396 0.737191 7.29603 0.73719 7.46399 1.15542L8.6934 4.21693C8.76492 4.39503 8.93208 4.51648 9.12356 4.52946L12.4151 4.75265C12.8648 4.78314 13.0478 5.34623 12.7019 5.6352L10.1701 7.75051C10.0229 7.87356 9.95901 8.07007 10.0058 8.25619L10.8107 11.4556C10.9207 11.8927 10.4417 12.2407 10.06 12.0011L7.26585 10.2469C7.10331 10.1449 6.89669 10.1449 6.73415 10.2469L3.94002 12.0011C3.55831 12.2407 3.07932 11.8927 3.18927 11.4556L3.99416 8.25619C4.04099 8.07007 3.97714 7.87356 3.82986 7.75051L1.2981 5.6352C0.952233 5.34623 1.13519 4.78314 1.58486 4.75265L4.87644 4.52946C5.06792 4.51648 5.23508 4.39503 5.3066 4.21693L6.53601 1.15543Z"
          fill="#FF9C42"
        />
      </svg>
    </span>
  </span>
);

const LpCompetitorTable = ({ slug, className }) => {
  const data = competitorData[slug];
  if (!data?.table) return null;

  const { heading, subheading, mangomintName, competitorName, rows } = data.table;

  const renderMobileDesktopContent = (content) => (
    <>
      <span className={c.desktopOnly}>{content.desktop}</span>
      <span className={c.mobileOnly}>{content.mobile}</span>
    </>
  );

  const renderRatingsContent = (content) => (
    <div className={c.ratingsContainer}>
      {content.capterra && (
        <p className={classNames(c.ratingItem, "p4")}>
          Capterra:
          <StarRating rating={content.capterra} />
        </p>
      )}
      {content.g2 && (
        <p className={classNames(c.ratingItem, "p4")}>
          G2:
          <StarRating rating={content.g2} />
        </p>
      )}
    </div>
  );

  const renderBooleanContent = (content) =>
    content ? (
      <IconCheckmark className={c.checkmark} width="15" height="11" aria-label="Yes" />
    ) : (
      <span aria-label="No">—</span>
    );

  const renderCellContent = (content) => {
    if (typeof content === "object" && content !== null) {
      if (content.desktop || content.mobile) {
        return renderMobileDesktopContent(content);
      }
      return renderRatingsContent(content);
    }

    if (typeof content === "boolean") {
      return renderBooleanContent(content);
    }

    return content;
  };

  return (
    <section className={classNames(className, c.container)}>
      <div className={c.headerContainer} data-transition="slide-enter-child">
        <h2 className="h3">{heading}</h2>
        <p className="p3">{subheading}</p>
      </div>

      <div className={c.tableContainer} data-transition="slide-enter">
        <div className={c.table}>
          <div className={c.tableHeader}>
            <div className={c.categoryColumn}></div>
            <div className={c.companyColumn}>
              <p className={classNames(c.companyName, "p3")}>
                <strong>{mangomintName}</strong>
              </p>
            </div>
            <div className={c.companyColumn}>
              <p className={classNames(c.companyName, "p3")}>
                <strong>{competitorName}</strong>
              </p>
            </div>
          </div>

          {rows.map((row, index) => (
            <div key={index} className={c.tableRow}>
              <div className={classNames(c.categoryColumn, c.categoryCell)}>
                <p className={classNames(c.categoryLabel, "p4")}>{row.category}</p>
              </div>
              <div className={classNames(c.companyColumn, c.contentCell, c.mangomintCell)}>
                <div className={classNames(c.cellContent)}>{renderCellContent(row.mangomint)}</div>
              </div>
              <div className={classNames(c.companyColumn, c.contentCell)}>
                <div className={classNames(c.cellContent)}>{renderCellContent(row.competitor)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LpCompetitorTable;
